import {store} from 'Store/store.index';
import React, { lazy } from 'react'
import { convertController, fileController, preferenceFullScreenController } from "../Controllers/index";
import intl from 'react-intl-universal';
import { observer, inject } from 'mobx-react'
import {DialogContainer, DLG_TARGETS} from '../EditorDialogsContainer'
 import {
  ORGANIZE_TAB_FLATTEN,
  ORGANIZE_TAB_WATERMARK_ADD,
  ORGANIZE_TAB_WATERMARK_UPDATE,
  ORGANIZE_TAB_WATERMARK_REMOVEALL,
  ORGANIZE_TAB_BACKGROUND_ADD,
  ORGANIZE_TAB_BACKGROUND_UPDATE,
  ORGANIZE_TAB_BACKGROUND_REMOVEALL,
  ORGANIZE_TAB_HEADER_FOOTER_ADD,
  ORGANIZE_TAB_HEADER_FOOTER_UPDATE,
  ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL,
  ORGANIZE_TAB_BATES_NUMBERING_ADD,
  ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL,
  ORGANIZE_TAB_PAGE_ROTATE_LEFT,
  ORGANIZE_TAB_PAGE_ROTATE_RIGHT,
  ORGANIZE_TAB_PAGE_INSERT_FROM_FILE,
  ORGANIZE_TAB_PAGE_INSERT_FROM_CLIPBOARD,
  ORGANIZE_TAB_PAGE_INSERT_BLANK_PAGE,
  ORGANIZE_TAB_PAGE_INSERT_INTO_FILE,
  ORGANIZE_TAB_PAGE_REVERSE,
} from '../ui/constants/organize.constants';
  import { download } from 'Api/index';

  type Props = {
    onClickCallback: any;
    containerCallbacks:any;
  };
  type State = {
    messageDlgCfg:any;
  };
  
@inject('appStore', 'driveStore', 'privateDriveStore', 'taskStore', 'userStore', 'collaborationStore')
@observer
export default class OrganizeTab extends React.Component<Props, State> {

  pdfui: any;
  state: State ={ messageDlgCfg:{},};

    constructor(props) {
        super(props);
    }

    componentDidMount(): void {
      const actions = {
        [ORGANIZE_TAB_HEADER_FOOTER_ADD]: () => {
            this.onShowHeaderFooterDlg('add');
        },
        [ORGANIZE_TAB_HEADER_FOOTER_UPDATE]: ()=>{
          this.onShowHeaderFooterDlg('update');
        },
        [ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL]: ()=>{
          this.onShowHeaderFooterDlg('remove');
        },
        [ORGANIZE_TAB_BATES_NUMBERING_ADD]: ()=>{
          this.onShowBatesNumberingDlg('add');
        },
        [ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL]: ()=>{
          this.onShowBatesNumberingDlg('remove');
        },

        [ORGANIZE_TAB_WATERMARK_ADD]:()=>{
          this.onShowWatermarkDlg('add');
        },
        [ORGANIZE_TAB_WATERMARK_UPDATE]:()=>{
          this.onShowWatermarkDlg('update');
        },
        [ORGANIZE_TAB_WATERMARK_REMOVEALL]:()=>{
          this.onShowWatermarkDlg('remove');
        },
        [ORGANIZE_TAB_BACKGROUND_ADD]:()=>{
          this.onShowBackgroundDlg('add');
        },
        [ORGANIZE_TAB_BACKGROUND_UPDATE]:()=>{
          this.onShowBackgroundDlg('update');
        },
        [ORGANIZE_TAB_BACKGROUND_REMOVEALL]:()=>{
          this.onShowBackgroundDlg('remove');
        },
        [ORGANIZE_TAB_FLATTEN]:()=>{
          this.onShowFlattenDlg();
        },
      };
      const {setupViewerActionCallback} = this.props.containerCallbacks;
      Object.keys(actions).map(name => {
        setupViewerActionCallback(name, actions[name]);
      })
    }

    onShowFlattenDlg = async()=>{
      window.pdfui.pdfViewer.stateHandlerManager.switchTo('hand');
      this.props.containerCallbacks.requestDocInfo(({ docPageCount, currentPageIndex })=>{
        this.setState({
          //showDlgTarget:'flatten',
          messageDlgCfg:{
            target: DLG_TARGETS.Flatten,
            config:{
              docPageCount,
              currentPageIndex,
              onOk: this.onOkByWFlattenDlg,
              onClose: this.onCloseByFlattenDlg
            }
          }
  
        })
  
      });
    }

    onCloseByFlattenDlg = ()=>{
      this.setState({
        messageDlgCfg:{
          target:''
        }
      })
    }

    onOkByWFlattenDlg = (setting)=>{
      this.setState({
        messageDlgCfg:{
          target:''
        }
      })
      fileController.flattenPDF(setting)
    }

    onShowBackgroundDlg = async (type, showParams = {successAfter:null, cancelAfter:null}) => {
      const fn = () => {
        this.setState({
          messageDlgCfg: {
            target: DLG_TARGETS.Background,
            config: {
              type,
              onOk: () => {
                showParams.successAfter && showParams.successAfter();
                this.closeMessageDialog();
              },
              onClose: () => {
                showParams.cancelAfter && showParams.cancelAfter();
                this.closeMessageDialog();
              }
            }
          },
        });
      };
  
      if (type === 'add' || type === 'update') {
        fn()
      } else if (type === 'remove') {
        const info = await fileController.getDocInfo();
        const data = await fileController.getPageFormat('background', 322, 386, info.fileName);
        const oldBackground = data.res && data.old;
        if (oldBackground) {
          this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
              if (isOk) {
                const res = await fileController.removeAllPageFormat('background')
                if (res === 1) {
                  fileController.getPDFViewer().then(viewer => {
                    viewer.redraw(true)
                  })
                  store.appStore.doUpdateDocModified(true);
                }
                showParams.successAfter && showParams.successAfter();
              } else {
                  showParams.cancelAfter && showParams.cancelAfter()
              }
            }, {
              message: 'background.removeMessage',
              checkbox: null,
              closable: false
            },
            false);
        } else {
          this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
              if (isOk) {
                  showParams.successAfter && showParams.successAfter();
              } else {
                  showParams.cancelAfter && showParams.cancelAfter()
              }
            }, {
              message: 'background.removeNoneMessage',
              checkbox: null,
              closable: true
            },
            true);
        }
      }
    };

    closeMessageDialog = () => {
      this.setState({
        messageDlgCfg: { target: '' },
      });
    };
    onShowWatermarkDlg = async (type, showParams = {successAfter:null, cancelAfter:null}) => {
      const fn = () => {
        this.setState({
          messageDlgCfg: {
            target: DLG_TARGETS.Watermark,
            config: {
              type,
              onOk: () => {
                showParams.successAfter && showParams.successAfter();
                this.closeMessageDialog();
              },
              onClose: () => {
                showParams.cancelAfter && showParams.cancelAfter();
                this.closeMessageDialog();
              },
            },
          },
        });
      };
  
      if (type === 'add' || type === 'update') {
        fn()
      } else if (type === 'remove') {
        const info = await fileController.getDocInfo();
        const data = await fileController.getPageFormat('watermark', 322, 386, info.fileName);
        const hasOldWatermark = data.res && data.old;
        if (hasOldWatermark) {
          this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
              if (isOk) {
                const res = await fileController.removeAllPageFormat('watermark')
                if (res === 1) {
                  fileController.getPDFViewer().then(viewer => {
                    viewer.redraw(true)
                  });
                  store.appStore.doUpdateDocModified(true);
                }
                showParams.successAfter && showParams.successAfter();
              } else {
                  showParams.cancelAfter && showParams.cancelAfter();
              }
            }, {
              message: 'watermark.removeMessage',
              checkbox: null,
              closable: false
            },
            false);
        } else {
          this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
              if (isOk) {
                  showParams.successAfter && showParams.successAfter();
              } else {
                  showParams.cancelAfter && showParams.cancelAfter();
              }
            }, {
              message: 'watermark.removeNoneMessage',
              checkbox: null,
              closable: true
            },
            true);
        }
      }
  
      // store.userStore.checkShowDlgControl('watermark');
      // const { watermark } = store.userStore.userTip;
      // if (watermark === 'hide') {
      //   fn();
      //   return;
      // }
      // this.onShowWarningMessage((isOk, state) => {
      //   isOk && fn();
      //   if (!isOk) return;
      //   if (state && state.checked !== void 0) {
      //     // checkd: true => do not show
      //     store.userStore.setShowDlgControl('watermark', !state.checked);
      //   }
      // }, { message: 'dialog.beforeShow', checkbox: { title: 'DoNotShowAgain', checked: true }, closable: true }, true);
  
    };

    onCloseByBatesNumberingDlg = () =>{
      this.setState({
        messageDlgCfg:{
          target:''
        }
      })
    }
    onOkByBatesNumberingDlg = async (result, docList, nameOpt, showParams = {successAfter:null, cancelAfter:null})=>{
      if (!window.pdfui) {
        return;
      }
      let successCnt = 0; //设置和下载成功数
  
      for (const item of docList) {
        const isCurrent = !item.doc;
        let pdfDoc = item.doc;
        let downFileName = item.name;
  
        result.sourceDoc = {
          docId: item.docId,
          fileName: item.name,
        }
  
        const res = await fileController.addPageFormat('batesNumbering', result, false)
        if (typeof res !== 'string') {
          continue;
        }
  
        successCnt++;
  
        // 当前打开的文件，刷新
        if (isCurrent) {
          fileController.getPDFViewer().then(viewer => {
            viewer.redraw(true)
          })
          pdfDoc = await fileController.pdfui.getCurrentPDFDoc();
        }
  
        // 下载文件
  
        switch (nameOpt.type) {
          case 2:
            downFileName = nameOpt.before + downFileName.substr(0, downFileName.length - 4) + nameOpt.after + '.pdf';
            break;
          case 3:
            downFileName = res + ".pdf"
            break;
        }
        const buffers = [];
        let flag = pdfDoc.hasSignature() ? 1 : 0;
        pdfDoc.getStream(({ arrayBuffer }) => {
          buffers.push(arrayBuffer);
        }, flag).then(() => {
          try {
            download(buffers, downFileName, 'application/octet-stream');
          } catch (ex) {
            // todo 没权限的后续弹窗提示
          }
        });
      }
  
      this.setState({
        messageDlgCfg: {
          target: '',
        },
      }, () => {
        this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
          if (isOk) {
              showParams.successAfter && showParams.successAfter();
          } else {
              showParams.cancelAfter && showParams.cancelAfter()
          }
        }, {
            message: 'batesNumbering.succesMessage',
            messageParams: {success: successCnt, total: docList.length},
            checkbox: null,
            closable: true
          },
          true);
      });
  
    }
    onShowBatesNumberingDlg = async(type, showParams = {successAfter:null,cancelAfter:null})=>{
      const fn = () => {
        this.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.BatesNumberingDialog,
              config: {
                showParams,
                alert: this.props.containerCallbacks.onShowWarningMessage,
                getDocInfo: () => {
                  return info;
                },
                updateFormat: (fileName, docId) => {
                  return fileController.getPageFormat('batesNumbering', 854, 248, fileName, docId)
                },
                getImage: (index, data, isUpdate, bitmapWidth, bitmapHeight, rotate) => {
                  return fileController.getPageFormatThumb('batesNumbering', index, data, isUpdate, bitmapWidth, bitmapHeight, rotate)
                },
                onOk: this.onOkByBatesNumberingDlg,
                onClose: this.onCloseByBatesNumberingDlg,
              },
            },
          },
        );
      };
      const info = await fileController.getDocInfo()
      let oldBatesNumbering = null;
      const localFormat = {
        fileName: intl.formatMessage({ id: 'headerfooter.options.fileName'}),
        date: intl.formatMessage({ id: 'headerfooter.options.pageFormat'}).split(",").join(`\\n`),
        dateLocal: intl.formatMessage({ id: 'headerfooter.options.pageFormatShow'}).split(",").join(`\\n`)
      };
      const data = await fileController.getPageFormat('batesNumbering', 854, 248, info.fileName, '', localFormat)
  
      if (data.res) {
        oldBatesNumbering = data.old
      }
  
      if (type === 'add') {
        fn()
      } else if (type === 'remove') {
        if (oldBatesNumbering) {
          this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
              if (isOk) {
                const res = await fileController.removeAllPageFormat('batesNumbering')
                if (res === 1) {
                  fileController.getPDFViewer().then(viewer => {
                    viewer.redraw(true)
                  })
                  store.appStore.doUpdateDocModified(true);
                }
                  showParams.successAfter && showParams.successAfter();
              } else {
                  showParams.cancelAfter && showParams.cancelAfter()
              }
            }, {
              message: 'batesNumbering.removeMessage',
              checkbox: null,
              closable: false
            },
            false);
        } else {
          const doc = await window.pdfui.getCurrentPDFDoc();
          if (await doc.isPdfaDoc()) {
            window.pdfui.alert({
              message: intl.formatMessage({ id: 'batesNumbering.permissionAlert' }),
              level: 'warning'
            })
            return;
          }
          this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
              if (isOk) {
                  showParams.successAfter && showParams.successAfter();
              } else {
                  showParams.cancelAfter && showParams.cancelAfter()
              }
            }, {
              message: 'batesNumbering.removeNoneMessage',
              checkbox: null,
              closable: true
            },
            true);
        }
      }
    }
  

    onOkByHeaderFooterDlg = async (result, isUpdate)=>{
      if (!window.pdfui) {
        return;
      }
      const res = await fileController.addPageFormat('headerfooter', result, isUpdate)
      if (res >= 0) {
  
        fileController.getPDFViewer().then(viewer => {
          viewer.redraw(true)
        })
        this.setState({
          messageDlgCfg: {
            target: '',
          },
        });
        store.appStore.doUpdateDocModified(true);
      }
      return res;
    }
    onCloseByHeaderFooterDlg = () =>{
      this.setState({
        messageDlgCfg:{
          target:''
        }
      })
    }
    onShowHeaderFooterDlg = async(type, showParams = {successAfter:null,cancelAfter:null})=>{
      const fn = (oldData) => {
        this.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.AddHeaderFooter,
              config: {
                showParams,
                oldData: oldData,
                alert: this.props.containerCallbacks.onShowWarningMessage,
                getDocInfo: () => {
                  return info;
                },
                getImage: (index, data, isUpdate, bitmapWidth, bitmapHeight, rotate) => {
                  return fileController.getPageFormatThumb('headerfooter', index, data, isUpdate, bitmapWidth, bitmapHeight, rotate)
                },
                onOk: this.onOkByHeaderFooterDlg,
                onClose: this.onCloseByHeaderFooterDlg,
              },
            },
          },
        );
      };
      const info = await fileController.getDocInfo()
      let oldHeaderfooter = null
      const localFormat = {
        fileName: intl.formatMessage({ id: 'headerfooter.options.fileName'}),
        date: intl.formatMessage({ id: 'headerfooter.options.pageFormat'}).split(",").join(`\\n`),
        dateLocal: intl.formatMessage({ id: 'headerfooter.options.pageFormatShow'}).split(",").join(`\\n`)
      };
      const data = await fileController.getPageFormat('headerfooter', 854, 248,
        info.fileName, '', localFormat)
      if (data.res) {
        oldHeaderfooter = data.old
      }
  
      if (type === 'add') {
        if (!oldHeaderfooter) {
          fn(null)
        } else {
          this.props.containerCallbacks.onShowWarningMessage((isOk) => {
              if (isOk) {
                fn(oldHeaderfooter)
              } else {
                fn(null)
              }
            }, {
              message: 'headerfooter.addMessage',
              ok: 'watermark.addUpdateBtn',
              cancel: 'watermark.addNewBtn',
              checkbox: null,
              closable: false
            },
            false);
        }
      } else if (type === 'update') {
        fn(oldHeaderfooter)
      } else if (type === 'remove') {
        if (oldHeaderfooter) {
          this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
              if (isOk) {
                const res = await fileController.removeAllPageFormat('headerfooter')
                if (res === 1) {
                  fileController.getPDFViewer().then(viewer => {
                    viewer.redraw(true)
                  });
                  store.appStore.doUpdateDocModified(true);
                }
                showParams.successAfter && showParams.successAfter();
              } else {
                  showParams.cancelAfter && showParams.cancelAfter();
              }
            }, {
              message: 'headerfooter.removeMessage',
              checkbox: null,
              closable: false
            },
            false);
        } else {
          this.props.containerCallbacks.onShowWarningMessage(async (isOk) => {
              if (isOk) {
                  showParams.successAfter && showParams.successAfter();
              } else {
                  showParams.cancelAfter && showParams.cancelAfter();
              }
            }, {
              message: 'headerfooter.removeNoneMessage',
              checkbox: null,
              closable: true
            },
            true);
        }
      }
    }

    render() 
    {
      const {messageDlgCfg} = this.state;
      return (
      <React.Fragment>
        {<DialogContainer {...messageDlgCfg}/>}
      </React.Fragment>
      )
    }
  
}
